import {
  combineComparators,
  compareAsDates,
  compareAsMagnitudes,
  compareAsNumbers,
  compareAsStrings,
} from 'comparators';
import ledgerAccountOrderingTypes from './ledgerAccountOrderingTypes';
import ledgerCategoryOrderingTypes from './ledgerCategoryOrderingTypes';

export const compareVendorNames = (dataEntryA, dataEntryB) =>
  compareAsStrings(dataEntryA.journalEntry.vendorName, dataEntryB.journalEntry.vendorName);

export const compareDataEntryLedgerAccountNames = (dataEntryA, dataEntryB) =>
  compareAsStrings(
    dataEntryA.ledgerAccount ? dataEntryA.ledgerAccount.name : '',
    dataEntryB.ledgerAccount ? dataEntryB.ledgerAccount.name : '',
  );

export const compareAmountMagnitudes = (dataEntryA, dataEntryB) =>
  compareAsMagnitudes(dataEntryA.amountInCents, dataEntryB.amountInCents);

export const compareAmountValues = (dataEntryA, dataEntryB) =>
  compareAsNumbers(dataEntryA.amountInCents, dataEntryB.amountInCents);

export const compareTransactionDates = (dataEntryA, dataEntryB) =>
  compareAsDates(
    dataEntryA.journalEntry.dateOfTransaction,
    dataEntryB.journalEntry.dateOfTransaction,
  );

export const compareTransferIds = (dataEntryA, dataEntryB) =>
  compareAsStrings(dataEntryA.journalEntry.transferId, dataEntryB.journalEntry.transferId);

export const compareAllDataEntries = combineComparators([
  compareVendorNames,
  compareDataEntryLedgerAccountNames,
  compareAmountMagnitudes,
  compareAmountValues,
  compareTransactionDates,
]);

export const dataEntryComparators = {
  [ledgerAccountOrderingTypes.DEFAULT]: combineComparators([
    compareVendorNames,
    compareAmountMagnitudes,
    compareAmountValues,
    compareTransactionDates,
  ]),
  [ledgerAccountOrderingTypes.MONEY_IN_TRANSIT]: combineComparators([
    compareTransferIds,
    compareAmountMagnitudes,
    compareAmountValues,
    compareVendorNames,
    compareTransactionDates,
  ]),
};

export const ledgerAccountComparators = {
  [ledgerCategoryOrderingTypes.ALPHABETICAL]: (ledgerA, ledgerB) =>
    compareAsStrings(ledgerA.name, ledgerB.name),
  [ledgerCategoryOrderingTypes.CUSTOM]: (ledgerA, ledgerB) =>
    compareAsNumbers(ledgerA.order, ledgerB.order),
};
